import * as Sentry from "@sentry/astro";

Sentry.init({
  dsn: "https://3502dc747e79fa21814b87fdbc9bad28@o4507275942952960.ingest.us.sentry.io/4507275945443328",
  debug: false,
  environment: import.meta.env.PUBLIC_VERCEL_ENV,
  release: import.meta.env.PUBLIC_VERCEL_GIT_COMMIT_SHA,
  tracesSampleRate: 1,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1,
});